<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="12" class="mt-2">
        <v-combobox
          v-model="fileName"
          color="grey darken-3"
          class="mb-2 select-file-combobox"
          :items="pages"
          label="Selecione um arquivo"
          dense
          hide-details
          clearable
          auto-select-first
          append-icon="expand_more"
        />
      </v-col>

      <v-col cols="12" class="d-flex align-center justify-center">
        <v-btn type="submit" color="grey darken-3" class="mr-2" outlined :disabled="!fileName" @click="handleGetPageByName">
          <v-icon color="grey darken-3" class="ml-1">import_export</v-icon>Editar
        </v-btn>

        <v-btn color="grey darken-3" @click="newSchema">
          <v-icon class="mr-2 white--text">open_in_new</v-icon>
          <span class="white--text font-weight-medium">Novo</span>
        </v-btn>
      </v-col>
    </v-row>

    <v-divider />

    <v-row v-if="typeOfPageEditing.length">
      <v-col cols="12" class="pb-0 my-2">
        <v-text-field v-model="schema.title" label="Título da página" color="grey darken-3" dense hide-details />
      </v-col>

      <v-col cols="12" class="pb-2 pt-1 mt-2">
        <input id="fileUpload" type="file" v-show="false" accept="image/*" @input="onFileUpload($event)" />

        <v-text-field
          v-model="schema.background.desktopImage"
          label="Desktop Image"
          prepend-icon="attach_file"
          color="grey darken-3"
          dense
          hint="Exemplo de uso: static/sua-imagem.png"
          @click:prepend="openFileOnClick('desktopImage')"
        />
      </v-col>

      <v-col cols="12" class="pb-2 pt-1 mb-2">
        <v-text-field
          v-model="schema.background.mobileImage"
          label="Mobile Image"
          prepend-icon="attach_file"
          color="grey darken-3"
          dense
          hint="Exemplo de uso: static/sua-imagem.png"
          @click:prepend="openFileOnClick('mobileImage')"
        />
      </v-col>

      <v-col cols="12" class="pb-2 pt-1 my-2">
        <devInputColorPicker
          :schema="{
            type: 'devInputColorPicker',
            model: 'desktopColor',
            label: 'desktopColor'
          }"
          :model="{ desktopColor: schema.background.desktopColor }"
          @changeModel="handleChangeDesktopColor"
        />
      </v-col>

      <v-col cols="12" class="pb-2 pt-1 my-2">
        <devInputColorPicker
          :schema="{
            type: 'devInputColorPicker',
            model: 'mobileColor',
            label: 'mobileColor'
          }"
          :model="{ mobileColor: schema.background.mobileColor }"
          @changeModel="handleChangeMobileColor"
        />
      </v-col>

      <v-col cols="12" class="pb-2 pt-1my-2">
        <v-switch v-model="schema.breadcrumbs" label="Breadcrumbs" color="grey darken-3" dense hide-details class="mt-0" />
      </v-col>

      <v-col cols="12">
        <v-card class="mx-auto">
          <v-list class="pb-0 pt-0" subheader dense>
            <v-subheader>Selecione os modos de tela:</v-subheader>
            <v-list-item-group v-model="modes" multiple>
              <template v-for="(mode, i) in defaultModes">
                <v-divider :key="`divider-${i}`"></v-divider>

                <v-list-item :key="`item-${i}`" :value="mode" @click="handleToggleModes(mode)" active-class="grey--text text--darken-3">
                  <template v-slot:default="{ active }">
                    <v-list-item-content>
                      <v-list-item-title style="text-transform: capitalize">{{ mode }}</v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-action>
                      <v-checkbox :input-value="active" :true-value="mode" color="grey darken-3" @click="handleToggleModes(mode)" dense></v-checkbox>
                    </v-list-item-action>
                  </template>
                </v-list-item>
              </template>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-col>

      <v-col cols="12" class="pb-0 pt-0 mt-2" v-if="typeOfPageEditing === 'new'">
        <v-btn color="grey darken-3" @click="newPage">
          <v-icon class="mr-2 white--text">open_in_new</v-icon>
          <span class="white--text font-weight-medium">Continuar</span>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { getPageByName } from '@/services/dev';
import { DEFAULT_MODES } from '@/helpers/dev';
import { randomString, addMandatoryParameters } from '@/helpers/dev';

export default {
  components: {
    devInputColorPicker: () => import('@/components/dev/dev-input-color-picker')
  },

  data() {
    return {
      defaultModes: ['list', 'form', 'new', 'search', 'sidebar'],
      uploadBackgroundModel: '',
      fileName: ''
    };
  },

  async created() {
    this.$store.dispatch('dev/getPages');
  },

  computed: {
    schema() {
      return this.$store.getters['dev/getSchema'];
    },

    initialSchema() {
      return this.$store.getters['dev/getInitialSchema'];
    },

    pages() {
      return this.$store.getters['dev/getPages'];
    },

    modes: {
      get() {
        return this.$store.getters['dev/getModes'];
      },

      set(val) {
        this.$store.dispatch('dev/setModes', val);
      }
    },

    selectedEnvironment() {
      return this.$store.getters['dev/getSelectedEnvironment'];
    },

    selectedPortal() {
      return this.$store.getters['dev/getSelectedPortal'];
    },

    selectedPage() {
      return this.$store.getters['dev/getSelectedPage'];
    },

    typeOfPageEditing() {
      if (this.$store.getters['dev/getTypeOfPageEditing'] === 'new') {
        this.fileName = '';
      }

      return this.$store.getters['dev/getTypeOfPageEditing'];
    }
  },

  methods: {
    dynamicComponent: () => import(`@/components/dev/dev-input-color-picker`),

    async handleGetPageByName() {
      if (this.typeOfPageEditing !== '' && JSON.stringify(this.schema) !== JSON.stringify(this.initialSchema)) {
        this.$store.dispatch('dev/setConfirmPageChanges', { dialog: true, origin: 'edit', fileName: this.fileName });

        return;
      }

      const { data: schema } = await getPageByName(this.selectedPortal.portalId, this.fileName, this.selectedEnvironment.id);

      await this.$store.dispatch('dev/setSchema', addMandatoryParameters(schema));

      await this.$store.dispatch('page/load', { page: 'dev', mode: this.modes[0] });

      this.$store.dispatch('dev/setCurrentMode', this.modes[0]);
      this.$store.dispatch('dev/setSelectedPage', this.fileName);
      this.$store.dispatch('dev/setTypeOfPageEditing', 'edit');

      this.$store.dispatch('dev/setInitialSchema', JSON.parse(JSON.stringify(addMandatoryParameters(schema))));
    },

    handleToggleModes(mode) {
      if (this.modes.includes(mode)) {
        delete this.schema[`${mode}`];
      } else {
        this.schema[`${mode}`] = JSON.parse(JSON.stringify(DEFAULT_MODES[`${mode}`]));
      }
    },

    openFileOnClick(model) {
      this.uploadBackgroundModel = model;

      document.getElementById('fileUpload').click();
    },

    onFileUpload(e) {
      const { name } = e.target.files[0];

      this.schema.background[`${this.uploadBackgroundModel}`] = name;
    },

    toggleColorBackground({ name, item }) {
      this.schema.background[name] = item;
    },

    newSchema() {
      if (this.typeOfPageEditing !== '' && JSON.stringify(this.schema) !== JSON.stringify(this.initialSchema)) {
        this.$store.dispatch('dev/setConfirmPageChanges', { dialog: true, origin: 'new', fileName: '' });

        return;
      }

      this.$store.dispatch('dev/setSchema');
      this.$store.dispatch('dev/setSelectedPage', '');
      this.$store.dispatch('dev/setInitialSchema', JSON.parse(JSON.stringify(this.schema)));
      this.$store.dispatch('dev/setTypeOfPageEditing', 'new');
      this.fileName = '';
    },

    async newPage() {
      if (this.schema.title === '') {
        this.$store.dispatch('notification/showNotification', {
          color: 'warning',
          text: 'Title required',
          showIconNotification: false
        });

        return;
      }

      if (!this.modes.length) {
        this.$store.dispatch('notification/showNotification', {
          color: 'warning',
          text: 'Mode required',
          showIconNotification: false
        });

        return;
      }

      if (this.schema.background.desktopImage.indexOf('/static/') !== 0 && this.schema.background.desktopImage !== '') {
        this.schema.background.desktopImage = `/static/${this.schema.background.desktopImage}`;
      }

      if (this.schema.background.mobileImage.indexOf('/static/') !== 0 && this.schema.background.mobileImage !== '') {
        this.schema.background.mobileImage = `/static/${this.schema.background.mobileImage}`;
      }

      this.$store.dispatch('dev/setSchema', this.schema);
      this.$store.dispatch('dev/setInitialSchema', JSON.parse(JSON.stringify(this.schema)));

      await this.$store.dispatch('page/load', { page: 'dev', mode: this.modes[0] });

      this.$store.dispatch('dev/setCurrentMode', this.modes[0]);
      this.$store.dispatch('dev/setSelectedPage', 'new');
    },

    handleChangeDesktopColor(e) {
      this.schema.background.desktopColor = e;
    },

    handleChangeMobileColor(e) {
      this.schema.background.mobileColor = e;
    }
  }
};
</script>

<style lang="scss">
.actions-page-dev {
  position: fixed;
  bottom: 10px;
  right: 10px;
  z-index: 5;

  .v-btn {
    margin: 10px;
  }
}
</style>
